module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "page-section container-fluid clearfix",
    attrs: {
      "id": "section-contact"
    }
  }, [_c('h2', {
    staticClass: "bottommargin"
  }, [_vm._v("Get in Touch")]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', [_vm._v("Located in Central Massachusetts, USA")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "line-height": "1.7"
    }
  }, [_c('p', [_vm._v("If you are interested in getting in touch for consulting sessions or projects please use the button below to get in touch.")]), _vm._v(" "), _c('div', {
    staticClass: "clear topmargin"
  }), _vm._v(" "), _c('a', {
    staticClass: "button button-3d button-xlarge button-rounded button-dirtygreen",
    attrs: {
      "href": "mailto:terri.ann.s@gmail.com"
    }
  }, [_vm._v("Email Me")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7c65fc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contact.vue
// module id = 111
// module chunks = 1